import React from 'react'
import { navData } from '../../navData'
import { NavLink } from 'react-router-dom'
// import './Sidebar.scss'

const Sidebar = ({ handleNavToggle, showNav }) => {
    return (
        <nav className='sidebar'>
            <ul className={`sidebar__nav-list ${showNav ? 'active' : ''}  `}>
                <li className='sidebar__close-icon-container'>
                    <img
                        className='sidebar__close-icon'
                        src='./assets/shared/icon-close.svg'
                        alt='Close Icon'
                        onClick={() => handleNavToggle()}
                    />
                </li>
                {navData.map((navItem, index) => {
                    let destinationText = navItem === '/' ? 'home' : navItem
                    return (
                        <li key={index} className='sidebar__nav-item'>
                            <NavLink
                                to={navItem}
                                className={({ isActive }) =>
                                    isActive
                                        ? 'sidebar__nav-link active'
                                        : 'sidebar__nav-link'
                                }
                            >
                                {' '}
                                <span>{`0${index}`}</span>
                                {destinationText}
                            </NavLink>
                            {/* <button className='sidebar__nav-link'>
                                {`0${index} ${navItem}`}
                            </button> */}
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}

export default Sidebar
